export default "__VITE_ASSET__W3g$rtEX__"